import { createContext, useEffect } from 'react'
import { setactiveItem } from 'store/cards';
import { clearCraftBlocks, setCraftBlocks } from 'store/crafting';
import { clearPredictionBlocks, getFiltersParams } from 'utils/crafting';
import { getCurrentData, getEligibles, getFilters } from 'services/craftPredictionService';
import useCraftPrediction from 'hooks/useCraftPrediction';
import CraftSelect from 'components/crafting/CraftSelect';
import CraftBlockPrediction from 'components/craft-prediction/CraftBlockPrediction';
import MainContentLeft from 'components/main-components/MainContentLeft';

export const CraftPredictionContext = createContext();

const CraftPrediction = () => {

  const {
    search, token, craftBlocks, refreshTrigger, dispatch, activeBlock, setActiveBlock,
    isEligiblesLoading, setIsEligiblesLoading, eligibles, setEligibles, queryParams, setQueryParams,
    selectCards, setSelectCards, filters, setFilters, activeFilters, setActiveFilters,
    paginationData, setPaginationData, offsetCount, setOffsetCount, resetCards, nextStep, playSound
  } = useCraftPrediction();

  const getDataSubUrl = (activeItem) => {
    switch (activeItem) {
      case 'Event':
        return 'event_date'
      case 'Trigger':
        return 'trigger'
      case 'Prize':
        return 'prize'
      default:
        return 'identity';
    }
  }

  const getCurrentOrder = () => {
    return activeBlock === 'Prize' ? 'low_high' : 'a_z'
  }

  const clearBlocks = () => {
    clearPredictionBlocks(dispatch, clearCraftBlocks, setActiveBlock, setEligibles, setQueryParams);
  }

  const selectItemHandler = (card) => {
    const selectInit = () => {
      const activeTag = activeBlock;
      const cardRarity = card.properties.find((prop) => prop.title === 'Rarity')?.text;

      dispatch(setCraftBlocks({ type: 'prediction', activeBlock, card, activeTag, cardRarity }))
      dispatch(setactiveItem(null))
      nextStep();
    }

    if (card.type === 'Event' && card.is_valid_event === true) {
      selectInit()
    } else if (card.type !== 'Event' && card.is_valid_event === false) {
      selectInit();
    }
  }

  const getParamId = () => {
    if (activeBlock === 'Event' && craftBlocks[0].value !== null) {
      return `&identity_id=${craftBlocks[0].value.id}`
    } else if (activeBlock === 'Identity' && craftBlocks[1].value !== null) {
      return `&event_id=${craftBlocks[1].value.id}`
    } else if (craftBlocks.every((item) => item.value === null)) {
      return ''
    } else {
      return `&identity_id=${craftBlocks[0].value.id}`
    }
  }


  const getActiveBlockData = () => {
    if (token && activeBlock !== '') {
      getCurrentData(
        resetCards,
        getDataSubUrl,
        activeBlock,
        getFiltersParams,
        activeFilters,
        offsetCount,
        getCurrentOrder,
        setSelectCards,
        setPaginationData,
        search,
        getParamId
      );
      dispatch(setactiveItem(null))
    } else {resetCards()}
  }

  const isLastCardAdded = craftBlocks.at(-1).value !== null;

  useEffect(() => {
    getActiveBlockData()
  }, [token, offsetCount, activeBlock, activeFilters, search, refreshTrigger]);

  useEffect(() => {
    getEligibles(craftBlocks, activeBlock, setIsEligiblesLoading, setEligibles);
  }, [refreshTrigger])

  useEffect(() => {
    setOffsetCount(0);

    return () => {
      setEligibles([])
      setPaginationData({})
      setActiveFilters([]);
    }
  }, [activeBlock, search])

  useEffect(() => {
    getFilters(activeBlock, setFilters);
  }, [activeBlock])



  return (
    <CraftPredictionContext.Provider
      value={{
        activeBlock,
        setActiveBlock,
        craftBlocks,
        isEligiblesLoading,
        setIsEligiblesLoading,
        eligibles,
        setEligibles,
        queryParams,
        setQueryParams,
        clearBlocks,
        nextStep,
        selectItemHandler,
        activeFilters,
        setActiveFilters,
        playSound
      }}
    >
      <main className="main-content">
        <MainContentLeft
          getOpenedClass={() => 'opened'}
        />
        <div className="main-content__right">
          <CraftBlockPrediction />
          <CraftSelect
            cards={selectCards}
            filters={filters}
            activeBlock={activeBlock}
            selectItemHandler={selectItemHandler}
            offsetCount={offsetCount}
            setOffsetCount={setOffsetCount}
            paginationData={paginationData}
            playSound={playSound}
            firstSelectedCard={getParamId()}
            isLastCardAdded={isLastCardAdded}
          />
        </div>
      </main>
    </CraftPredictionContext.Provider>
  )
}

export default CraftPrediction;
